module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/103.fb6ad2b1.png";